var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121.37 97.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff6e45;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.49,48.58l36,20.09-.16,0L26.24,92.08l-.11,0,21-35.52,10,5.23A10.18,10.18,0,0,0,70.48,58.2ZM101.4,8.78a3.26,3.26,0,0,1,.25.61L115.93,62a5.87,5.87,0,0,1,.09,2.69L79.24,44.18Zm-96.06,26L42.51,54.2,21.05,90.48a5.92,5.92,0,0,1-1.33-2.4L5.45,35.5a5.46,5.46,0,0,1-.1-.69Zm3.72-6L95.14,5.42a5.27,5.27,0,0,1,2.23-.09L66,55.42a4.72,4.72,0,0,1-6.45,1.75L7.13,29.82a5.36,5.36,0,0,1,1.93-1ZM7.69,23.73A10.67,10.67,0,0,0,.38,36.88L14.66,89.45a10.71,10.71,0,0,0,13,7.7L113.7,73.78A10.71,10.71,0,0,0,121,60.59L106.72,8a10.67,10.67,0,0,0-13-7.65Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalMail);
export default __webpack_public_path__ + "static/media/ModalMail.bac5842c.svg";
export { ForwardRef as ReactComponent };